(() => {
  const timezone = 'America/Los_Angeles';
  const millisecondsPerDay = 86400000;
  const defaultStart = Date.UTC(2026, 9, 7) / millisecondsPerDay;
  function isoDay(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return NaN;
    const date = new Date(`${value}T00:00:00Z`);
    if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) return NaN;
    return date.getTime() / millisecondsPerDay;
  }
  function pacificDay(date = new Date()) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(date);
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    return Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day)) / millisecondsPerDay;
  }
  function rotationIndex(day, start, count) {
    if (!count) return 0;
    const anchor = Number.isFinite(start) ? start : defaultStart;
    return ((day - anchor) % count + count) % count;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { isoDay, pacificDay, rotationIndex };
    return;
  }
  if (window.__bbhDailyHero) return;
  window.__bbhDailyHero = true;
  function render(root, template) {
    const photo = root.querySelector('[data-bbh-hero-photo]');
    if (!photo || !template) return;
    root.classList.toggle('bbh-hero--copy-right', template.dataset.copySide === 'right');
    root.dataset.rotationBlock = template.dataset.blockId || 'fallback';
    photo.replaceChildren(template.content.cloneNode(true));
  }
  function refresh(root, force = false) {
    if (root.dataset.rotationEnabled !== 'true') return;
    const options = [...root.querySelectorAll('template[data-bbh-hero-option]')];
    const fallback = root.querySelector('template[data-bbh-hero-fallback]');
    const override = root.dataset.rotationPreview === 'true'
      ? isoDay(new URLSearchParams(window.location.search).get('bbh_hero_date')) : NaN;
    const day = Number.isFinite(override) ? override : pacificDay();
    if (!force && root.dataset.rotationDay === String(day)) return;
    root.dataset.rotationDay = String(day);
    if (!options.length) { render(root, fallback); return; }
    const start = isoDay(root.dataset.rotationStart);
    const index = rotationIndex(day, start, options.length);
    let attempts = 0;
    const show = selected => {
      render(root, options[selected]);
      const image = root.querySelector('[data-bbh-hero-photo] img');
      if (image) image.addEventListener('error', () => {
        attempts += 1;
        if (attempts < options.length) show((selected + 1) % options.length);
        else render(root, fallback);
      }, { once: true });
    };
    show(index);
  }
  function initialize(scope = document) {
    if (scope.matches?.('[data-bbh-daily-hero]')) refresh(scope);
    scope.querySelectorAll('[data-bbh-daily-hero]').forEach(root => refresh(root));
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    if (!window.Shopify?.designMode) return;
    document.querySelectorAll('[data-bbh-daily-hero]').forEach(root => {
      const option = [...root.querySelectorAll('template[data-bbh-hero-option]')]
        .find(template => template.dataset.blockId === event.detail.blockId);
      if (option) { root.dataset.editingBlock = option.dataset.blockId; render(root, option); }
    });
  });
  document.addEventListener('shopify:block:deselect', () => {
    document.querySelectorAll('[data-bbh-daily-hero]').forEach(root => {
      delete root.dataset.editingBlock;
      refresh(root, true);
    });
  });
  function refreshDay() {
    document.querySelectorAll('[data-bbh-daily-hero]').forEach(root => {
      if (!root.dataset.editingBlock) refresh(root);
    });
  }
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshDay();
  });
  window.setInterval(refreshDay, 60000);
})();
